/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Chkk Admin API v1.0
 * Chkk Admin API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * The status of an upgrade template
 */
export type UpgradeTemplateStatus =
  (typeof UpgradeTemplateStatus)[keyof typeof UpgradeTemplateStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpgradeTemplateStatus = {
  pending: 'pending',
  'in-progress': 'in-progress',
  available: 'available',
  completed: 'completed',
  'cancellation-in-progress': 'cancellation-in-progress',
  cancelled: 'cancelled',
  outdated: 'outdated',
  'update-in-progress': 'update-in-progress',
  'regenerate-in-progress': 'regenerate-in-progress',
  approved: 'approved',
  archived: 'archived',
} as const;
